import { createParser } from 'nuqs';
import { ListViewSort } from '../types';

/**
 * nuqs parser for MRT-style sort in the URL. Encodes as "columnId asc" | "columnId desc".
 *
 * - parse: reads the query string and returns { id, desc } or null when invalid/missing.
 * - serialize: writes { id, desc } to "columnId asc" | "columnId desc".
 * - eq: used when clearOnDefault is set; compares two sort values by id and desc.
 */
export const parseAsMrtSort = createParser<ListViewSort>({
  parse(value) {
    if (!value || typeof value !== 'string') return null;
    const parts = value.trim().split(/\s+/);
    if (parts.length < 2) return null;
    const [id, order] = parts;
    return { id, desc: order.toLowerCase() === 'desc' };
  },
  serialize(value) {
    return `${value.id} ${value.desc ? 'desc' : 'asc'}`;
  },
  eq(a, b) {
    return a.id === b.id && a.desc === b.desc;
  },
});
